import { BadgeCheck, Sparkles } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Tip } from "@/components/ui/overlays";
import { useEntitlements } from "@/hooks/use-entitlements";
import { useBilling } from "@/hooks/use-billing";
import { useShell } from "@/stores/shell";

/**
 * Top-right billing entry point. Opens the standalone billing dialog (see
 * `AppShell.tsx`), which mounts the same `<BillingPanel>` as Settings →
 * Billing — one component, two containers. Hidden entirely when this
 * deployment has no billing configured (local/self-hosted mode has no
 * paywall to speak of).
 */
export function UpgradeButton({ className }: { className?: string }) {
  const billing = useBilling();
  const entitlements = useEntitlements();

  if (billing.data && !billing.data.enabled) return null;

  const bothActive = entitlements.billingEnabled && entitlements.storageUnlimited && entitlements.modelsPremium;

  return (
    <Tip label={bothActive ? "Manage your plan" : "Upgrade — unlimited storage & frontier models"}>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className={className}
        onClick={() => useShell.getState().openBilling()}
      >
        {bothActive ? (
          <BadgeCheck className="h-3.5 w-3.5 text-primary" />
        ) : (
          <Sparkles className="h-3.5 w-3.5 text-primary" />
        )}
        {bothActive ? "Plan" : "Upgrade"}
      </Button>
    </Tip>
  );
}
